import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const getAnnouncementNewsPaging = async (params) => {
  return await api.post("/v1/announcement/getAnnouncementNewsPaging", params);
};

export const getAnnouncementNewsSettingPaging = async (params) => {
  return await api.post("/v1/announcement/getAnnouncementNewsSettingPaging", params);
};

export const getAnnouncementNews = async (params) => {
  return await api.post("/v1/announcement/getAnnouncementNews", params);
};

export const createAnnouncementNews = async (params) => {
  return await apiFormData.post(
    "/v1/announcement/createAnnouncementNews",
    params,
    {
      isFormData: true,
    }
  );
};

export const updateAnnouncementNews = async (params) => {
  return await apiFormData.post(
    "/v1/announcement/updateAnnouncementNews",
    params,
    {
      isFormData: true,
    }
  );
};

export const manageAnnouncementNewsStatus = async (params = {}) => {
  return await api.post("/v1/announcement/manageAnnouncementNewsStatus", params);
};

export const getDropDown = async (params = {}) => {
  return await api.post("/v1/dropdown/getEmployee", params);
};
